import React, { useState } from "react";
import Login from "./Login";
import TexasSignUp from "./signup/texas/TexasSignUp";

const Authentication = (props) => {
  const [authType, setAuthType] = useState(props.authType || "login");

  return authType === "login" ? (
    <Login onChangeAuthType={setAuthType} />
  ) : (
    <TexasSignUp
      subscriptionPlans={props.subscriptionPlans}
      edPrepPrograms={props.edPrepPrograms}
      onChangeAuthType={setAuthType}
    />
  );
};

export default Authentication;
